import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { openWhatsApp } from '../lib/whatsapp';

const { FiArrowUpRight } = FiIcons;

function CtaSection() {
  return (
    <section className="cta-section" id="cta">
      <motion.div
        className="cta-inner"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
      >
        <p className="eyebrow eyebrow-light">Have a space in mind?</p>
        <h2>
          Let's make it
          <br />
          <em>feel like home.</em>
        </h2>
        <button className="cta-button" type="button" onClick={() => openWhatsApp()}>
          Tell us about your project
          <SafeIcon icon={FiArrowUpRight} />
        </button>
      </motion.div>
    </section>
  );
}

export default CtaSection;
